import { Link } from "react-router-dom";
import { ArrowRight, Gauge, Weight } from "lucide-react";
import { formatINR } from "@/lib/api";
import { mediaUrl } from "@/lib/media";
import WhatsAppInquireButton from "@/components/WhatsAppInquireButton";

export default function ProductCard({ p }) {
  return (
    <Link
      to={`/products/${p.slug}`}
      className="card-industrial group relative block"
      data-testid={`product-card-${p.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
        <img
          src={mediaUrl(p.image)}
          alt={p.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {p.featured && (
          <span className="absolute top-3 left-3 tag-saffron">Featured</span>
        )}
        <div className="absolute bottom-3 right-3 bg-[#1A1A1A] text-white px-3 py-1 text-xs uppercase tracking-widest font-bold">
          {p.brand}
        </div>
      </div>
      <div className="p-5">
        <div className="text-[11px] uppercase tracking-[0.2em] text-gray-500 font-semibold">{p.category}</div>
        <h3 className="font-heading font-black text-lg leading-tight mt-1 uppercase tracking-tight group-hover:text-[#E65C00] transition-colors">
          {p.title}
        </h3>
        <div className="flex items-center gap-4 mt-3 text-xs text-gray-600">
          {p.power_hp ? (
            <span className="flex items-center gap-1"><Gauge className="w-3.5 h-3.5 text-[#E65C00]" /> {p.power_hp} HP</span>
          ) : null}
          {p.weight ? (
            <span className="flex items-center gap-1"><Weight className="w-3.5 h-3.5 text-[#E65C00]" /> {p.weight}</span>
          ) : null}
        </div>
        <div className="flex items-end justify-between mt-4 pt-4 border-t border-gray-200 gap-3">
          <div className="font-heading font-black text-sm uppercase tracking-widest text-[#1A1A1A] inline-flex items-center gap-1">
            View Details <ArrowRight className="w-4 h-4 group-hover:translate-x-1 group-hover:text-[#E65C00] transition-all" />
          </div>
          <WhatsAppInquireButton itemTitle={p.title} kind="product" />
        </div>
      </div>
    </Link>
  );
}
